export enum $flaw {
  _id = '_id',
  issueId = 'issueId',
  flawPageId = 'flawPageId',
  ruleId = 'ruleId',
  toolId = 'toolId',
  firstFound = 'firstFound',
  lastFound = 'lastFound',
  data = 'data',
  embeddings = 'embeddings',
  status = 'status',
  statusHistory = 'statusHistory',
  taskId = 'taskId',
  viewed = 'viewed',
  tenantId = 'tenantId',
  workspaceId = 'workspaceId',
  digitalPropertyId = 'digitalPropertyId',
  tool = 'tool',
  commonFlawId = 'commonFlawId',
  hdbClusterId = 'hdbClusterId',
  hdbClusterProcessed = 'hdbClusterProcessed',
  rule = 'rule',
  _migrated = '_migrated',
  updatedAt = 'updatedAt',
  mobileOccurrenceCount = 'mobileOccurrenceCount',
}

export enum $flawPage {
  _id = '_id',
  tenantId = 'tenantId',
  workspaceId = 'workspaceId',
  digitalPropertyId = 'digitalPropertyId',
  url = 'url',
  urlHash = 'urlHash',
  firstScan = 'firstScan',
  lastScan = 'lastScan',
  lastMonitoredScan = 'lastMonitoredScan',
  date = 'date',
  scanId = 'scanId',
  flawsCount = 'flawsCount',
  selected = 'selected',
  title = 'title',
  important = 'important',
  pageId = 'pageId',
  mobileScreenId = 'mobileScreenId',
  _commonFlawsProcessed = '_commonFlawsProcessed',
  _commonFlawsProcessedAt = '_commonFlawsProcessedAt',
  _commonFlawsProcessedAtLeastOnce = '_commonFlawsProcessedAtLeastOnce',
}

export enum flawStatus {
  closed = 'closed',
  dismissed = 'dismissed',
  open = 'open',
  reOpen = 'reOpen',
}

export enum resolvedFindingStatus {
  resolved = 'resolved',
  unresolved = 'unresolved',
  resolvedDeleted = 'resolvedDeleted',
  unresolvedDeleted = 'unresolvedDeleted',
}

export enum commonFlawsProcessStatus {
  pending = 'pending',
  processing = 'processing',
  completed = 'completed',
}

export enum changedByType {
  user = 'user',
  scan = 'scan',
}

export enum $flawCreationMetadata {
  idPrefix = 'idPrefix',
  tenantId = 'tenantId',
  workspaceId = 'workspaceId',
  digitalPropertyId = 'digitalPropertyId',
  flawPageId = 'flawPageId',
  toolId = 'toolId',
  tool = 'tool',
  scanId = 'scanId',
  date = 'date',
  scanningType = 'scanningType',
  scanOrigin = 'scanOrigin',
}

export enum $flawEmbeddings {
  flawEmbeddingV1 = 'flawEmbeddingV1',
}

export enum $flawDataCreateRequest {
  ruleId = 'ruleId',
  data = 'data',
  embeddings = 'embeddings',
}

export enum $flawDataUpdateRequest {
  flawId = 'flawId',
  data = 'data',
  existingFlawData = 'existingFlawData',
  embeddings = 'embeddings',
}

export const linkableIssueStatus: ReadonlyArray<flawStatus> = Object.freeze([flawStatus.open, flawStatus.reOpen]);

export const resolvedFlawStatus: ReadonlyArray<flawStatus> = Object.freeze([flawStatus.closed, flawStatus.dismissed]);

export const DEFAULT_FLAW_BY_SCAN_PAGE_LIMIT = 100;
export const MAX_FLAW_BY_SCAN_PAGE_LIMIT = 1000;

export const DEFAULT_FINDINGS_BY_SCAN_PAGE_LIMIT = 100;
export const MAX_FINDINGS_BY_SCAN_PAGE_LIMIT = 1000;
export const MAX_ELEMENT_HTML_LENGTH = 100;
